import { orderTotal, transactionsTotal } from "@/utils/guestOrderTotal";
import { ORDER_STATUSES, getStatusColors } from "@/utils/guestOrderStatus";
import reportService from "@/services/report";

export default {
  data() {
    return {
      orderStatuses: ORDER_STATUSES,
      prepTimeDialogOpen: false,
      prepTimeTarget: null,
    };
  },
  methods: {
    /**
     * Stavke menija statusa. Trenutno stanje koje nije među njima (npr. "preparing") dolazi na vrh da se vidi gde je
     * narudžba; ostalo se i dalje bira iz iste liste.
     */
    statusMenuItems(state) {
      if (!state || this.orderStatuses.some((item) => item.value === state)) {
        return this.orderStatuses;
      }
      return [{ value: state, icon: "mdi-circle-outline" }, ...this.orderStatuses];
    },
    /** Boje trenutnog stanja u meniju, iste kao na značci u tabeli */
    currentStatusStyle(state) {
      const colors = getStatusColors(state);
      return { background: colors.bg, color: colors.fg };
    },
    // Accepting an order asks for a prep time first, same as on the kitchen
    // display board - either "ready immediately" or "ready in X minutes".
    // Every other status change goes straight through.
    requestStatusChange(order, guest, newStatus) {
      if (newStatus === "accepted") {
        this.prepTimeTarget = { order, guest };
        this.prepTimeDialogOpen = true;
        return;
      }
      this.$emit("change-status", { order, guest, newStatus });
    },
    // minuti pripreme idu uz prihvatanje kao vreme spremnosti (vidi reportService.rememberPrepMinutes)
    confirmPrepMinutes(minutes) {
      reportService.rememberPrepMinutes(this.prepTimeTarget.order.id, minutes);
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "accepted",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    confirmReadyNow() {
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "ready",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    isAsapOrder(order) {
      return !!(order && order.delivery_type === 0 && !order.delivery_time);
    },
    formatOrderTime(order) {
      if (!order) return "";
      if (order.delivery_time) {
        return order.delivery_time.substring(0, 5);
      }
      if (this.isAsapOrder(order) && order.created_at) {
        return new Date(order.created_at).toLocaleTimeString("sr-Latn", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return "";
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
    statusChipStyle(status) {
      const colors = this.getStatusColors(status);
      return { backgroundColor: colors.bg, color: colors.fg };
    },
    statusDotStyle(status) {
      return { backgroundColor: this.getStatusColors(status).fg };
    },
    orderSubtotal(order) {
      if (!order || !order.order_guest_transactions) return 0;
      return transactionsTotal(order.order_guest_transactions);
    },
    calculateTotal(item) {
      if (!item.orders_guest || !item.orders_guest.length) return 0;

      return item.orders_guest.reduce((total, order) => total + orderTotal(order), 0);
    },
  },
};
